import { Location } from '@cobliteam/common-types';
import { PermissionsGate } from '@cobliteam/permissions';
import { Button, Divider, Typography } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import { useHistory } from 'react-router-dom';
import PathAssociationPermissions from '../../../../permissions';
import FaceRecognitionDialog from './FaceRecognitionDialog';
import FaceRecognitionThumbs from './FaceRecognitionThumbs';

const FaceRecognitionBanner = () => {
  const history = useHistory();

  const handleClick = () => {
    history.push(Location.DRIVER_MANAGEMENT_NOT_IDENTIFIED);
  };

  return (
    <div className='flex w-full items-center justify-between rounded-md border border-gray-light p-3'>
      <div className='flex items-center gap-3'>
        <Icon name='smile-plus' size='lg' color='primary' />
        <div className='flex flex-col'>
          <div className='flex items-center gap-1'>
            <Typography variant='description-title'>Identifique seus motoristas</Typography>
            <FaceRecognitionDialog />
          </div>
          <Typography variant='caption-default' color='secondary'>
            Para garantir a precisão dos vídeos, associe as fotos dos motoristas que ainda não foram reconhecidos.
          </Typography>
        </div>
      </div>
      <PermissionsGate permissions={[PathAssociationPermissions.UPDATE_DRIVER_FACE_CLUSTER]}>
        <Divider orientation='vertical' className='mx-5 h-14' />
        <div className='flex items-center gap-2'>
          <FaceRecognitionThumbs />
          <Button variant='ghost' className='px-2' onClick={handleClick}>
            Identificar motoristas
          </Button>
        </div>
      </PermissionsGate>
    </div>
  );
};

export default FaceRecognitionBanner;
